// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import Select from '../controls/Select'
import MultiSelect from '../controls/MultiSelect'
import { BlockWrapper, renderEmptyMessage } from '../StatisticMetricsPage'
import type { Counter } from '../StatisticMetricsPage'
import LabeledWrapper from '../AudienceEdit/LabeledWrapper'
import type { OptionType } from '../types'
import { translations, translateFunc } from '../../shared/localize'

type Props = {|
  allCounters: Array<Counter>,
  counterOptions: Array<OptionType>,
  selectedCounterId: string,
  selectedGoalIds: Array<string>,
  isLoading: boolean,
  onChange: Function
|}

const t = translateFunc(translations.statistic_metrics_page)

export default class YandexBlock extends Component<Props> {
  render() {
    const { counterOptions, selectedCounterId, selectedGoalIds, isLoading, onChange } = this.props

    if (_.isEmpty(counterOptions)) return renderEmptyMessage()

    return (
      <BlockWrapper>
        <LabeledWrapper className="t-CounterSelect__metrica" label={t('choose_counter')} twoLines>
          <Select
            value={selectedCounterId}
            options={counterOptions}
            onChange={(counter) =>
              this.props.onChange({ selectedYandexCounterId: counter, selectedYandexGoalIds: [] })
            }
            disabled={this.props.isLoading}
          />
        </LabeledWrapper>
        <LabeledWrapper className="t-GoalsSelect__metrica" label={t('choose_goals')} twoLines>
          <MultiSelect
            placeholder={t('goals_placeholder')}
            noResultsText={t('no_goals_message')}
            value={selectedGoalIds}
            options={this.goalOptions()}
            onChange={(goalIds) => onChange({ selectedYandexGoalIds: goalIds })}
            disabled={isLoading}
          />
        </LabeledWrapper>
      </BlockWrapper>
    )
  }

  goalOptions(): Array<OptionType> {
    const { allCounters, selectedCounterId } = this.props
    const initialCounter = _.find(allCounters, (counter) => {
      return _.isEqual(counter.id, selectedCounterId) && _.isEqual(counter.provider, 'metrica')
    })
    return initialCounter
      ? _.map(initialCounter.goals, (goal) => {
          return { id: `${initialCounter.id}_${goal.id}`, name: goal.name }
        })
      : []
  }
}
